import { Button } from 'react-aria-components';

import { focusRingClassName } from '#/shared/utils/domHelper';

import { MaterialIcon } from './MaterialIcon';

interface BackActionButtonProps {
  onPress: () => void;
  children: React.ReactNode;
}

export function BackActionButton({ onPress, children }: Readonly<BackActionButtonProps>) {
  return (
    <Button
      onPress={onPress}
      className={`mb-8 flex items-center text-16 font-400 text-primary hover:text-primary-on-surface hover:cursor-pointer ${focusRingClassName}`}
    >
      <MaterialIcon size="sm" iconName="keyboard_arrow_left" className="-ml-[5px]" /> {children}
    </Button>
  );
}
